import * as React from 'react';

import AddressModel from 'src/model/address.model';

import './AddressDescription.scss';
import i18n from 'src/translation/i18n';

interface IAddressDescriptionProps {
  address: AddressModel;
  buttonText?: string;
  handleClicDeliverAddress(
    address: AddressModel,
    oneTimeAddress: boolean
  ): void;
}

class AddressDescription extends React.Component<
  IAddressDescriptionProps,
  any
> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const buttonText = this.props.buttonText
      ? this.props.buttonText
      : `${i18n.t('product.deliverToAddress')}`;
    return (
      <div className="rp-address-description">
        <label className="rp-address-description--name">
          {this.props.address.name.toLowerCase()}
        </label>
        <div className="rp-address-description--description">
          {`${
            this.props.address.addressLine1
              ? `${this.props.address.addressLine1.toLocaleLowerCase()}, `
              : ''
          }${
            this.props.address.addressLine2
              ? `${this.props.address.addressLine2.toLocaleLowerCase()}, `
              : ''
          }${
            this.props.address.addressLine3
              ? `${this.props.address.addressLine3.toLocaleLowerCase()}, `
              : ''
          }${
            this.props.address.addressLine4
              ? `${this.props.address.addressLine4.toLocaleLowerCase()}, `
              : ''
          }${
            this.props.address.stateCode
              ? `${this.props.address.stateCode} `
              : ''
          }${
            this.props.address.postalCode
              ? `${this.props.address.postalCode}`
              : ''
          }`}
        </div>
        <button
          className="primary-button rp-address-description--button"
          onClick={e =>
            this.props.handleClicDeliverAddress(this.props.address, false)
          }
        >
          {buttonText}
        </button>
      </div>
    );
  }
}

export default AddressDescription;
